var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.5C5.8525 1.5 2.5 4.8525 2.5 9C2.5 13.1475 5.8525 16.5 10 16.5C14.1475 16.5 17.5 13.1475 17.5 9C17.5 4.8525 14.1475 1.5 10 1.5ZM13.75 11.6925L12.6925 12.75L10 10.0575L7.3075 12.75L6.25 11.6925L8.9425 9L6.25 6.3075L7.3075 5.25L10 7.9425L12.6925 5.25L13.75 6.3075L11.0575 9L13.75 11.6925Z",
    fill: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.5C5.8525 1.5 2.5 4.8525 2.5 9C2.5 13.1475 5.8525 16.5 10 16.5C14.1475 16.5 17.5 13.1475 17.5 9C17.5 4.8525 14.1475 1.5 10 1.5ZM13.75 11.6925L12.6925 12.75L10 10.0575L7.3075 12.75L6.25 11.6925L8.9425 9L6.25 6.3075L7.3075 5.25L10 7.9425L12.6925 5.25L13.75 6.3075L11.0575 9L13.75 11.6925Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.866211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.aa7005ae1543cb9fd570454ae1f9405b.svg";
export { ForwardRef as ReactComponent };